import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { ILocalizedInformation, IProduct, ITheme } from '@inter-ikea-kompis/types';
import { ProductUtility } from '@inter-ikea-kompis/utilities';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import { QrCode } from '@inter-ikea-kompis/component-qr-code';
import { Text } from '@inter-ikea-kompis/component-text';

import type IEnergyEfficiencyClassTranslations from '../../types/IEnergyEfficiencyClassTranslations.js';
import EprelQrStyle from './EprelQrStyle.js';

/**
 * Data-driven information listing.
 */

export default class EprelQr extends KompisElement {
	// A product.
	@property({ type: Object, required: true })
	public product!: IProduct;

	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	// Localized information. Deprecated - use "translations" instead.
	@property({ type: Object })
	public localizedInformation: ILocalizedInformation | null = null;

	// The translations retrieved from translations service.
	@property({ type: Object })
	public translations: IEnergyEfficiencyClassTranslations | null = null;

	/**
	 * @returns Template.
	 */
	public override render(): RenderResult {
		// We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
		if (!this.hasTranslations()) {
			// We can't throw an error because on the first render no props are set.
			return null;
		}

		const link = ProductUtility.getProductInformationSheetLink(this.product);
		if (!link) {
			return null;
		}

		return html`
			<style>
				${EprelQrStyle.getStyle({
					theme: this.theme
				})}
			</style>
			<div class="container">
				<kompis-text .theme="${this.theme}">
					${this.getTranslations().energyClassEprelQrDescription}
				</kompis-text>
				<kompis-qr-code .url="${link.href}"></kompis-qr-code>
			</div>
		`;
	}

	public override connectedCallback(): void {
		this.customElements.define('kompis-qr-code', QrCode);
		this.customElements.define('kompis-text', Text);

		super.connectedCallback();
	}
	private hasTranslations(): boolean {
		return !!this.translations || !!this.localizedInformation?.translations;
	}

	private getTranslations(): IEnergyEfficiencyClassTranslations {
		const translations = this.translations
			? this.translations
			: this.localizedInformation?.translations;

		return <IEnergyEfficiencyClassTranslations>translations;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-eprel-qr': EprelQr;
	}
}
